import { __module as a } from "./ghl-ui.es1728.js";
import { i as l } from "./ghl-ui.es1541.js";
import { g as m } from "./ghl-ui.es1686.js";
import { s as O } from "./ghl-ui.es1706.js";
import { r as x } from "./ghl-ui.es1637.js";
(function(o, e) {
  var r = l.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var s = r(m), u = r(O), f = r(x);
  function i(p) {
    (0, f.default)(1, arguments);
    var d = (0, s.default)(p), t = /* @__PURE__ */ new Date(0);
    t.setUTCFullYear(d, 0, 4), t.setUTCHours(0, 0, 0, 0);
    var n = (0, u.default)(t);
    return n;
  }
  o.exports = e.default;
})(a, a.exports);
var k = a.exports;
export {
  k as s
};
